import { alpha, createTheme } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";

const palette = {
  mode: "dark",
  primary: {
    main: "#78faf3",
  },
  secondary: {
    main: "#bbc1f3",
  },
  tertiary: {
    main: "#E636C4",
  },
  background: {
    paper: "#282e37",
    default: "#282e37",
  },
  header: {
    main: "#1A2029",
  },
  progress: {
    main: "#a8efff",
  },
};

export const theme = createTheme({
  palette,
  typography: {
    fontFamily: "milliard-thin, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background: `linear-gradient(135deg, ${palette.secondary.main} 30%, ${palette.primary.main} 95%)`,
          border: 0,
          borderRadius: 3,
          boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
          color: "#FFFFFF",
          fontFamily: "notosans-regular",
          fontWeight: 700,
          height: 48,
          padding: "0 30px",
          "&.InProgress": {
            boxShadow: "none",
            color: "#fff",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          border: "2px solid transparent",
          background: `linear-gradient(${palette.background.paper} 0 0) padding-box, linear-gradient(to right, ${palette.secondary.main} 30%, ${palette.primary.main} 95%) border-box`,
          "&:hover": {
            background: `linear-gradient(${palette.background.paper} 0 0) padding-box, linear-gradient(to right, ${palette.secondary.main} 0 0) border-box`,
            ".MuiChip-deleteIcon": {
              color: palette.secondary.main,
            },
          },
          "&.Mui-focusVisible": {
            background: `linear-gradient(${palette.background.paper} 0 0) padding-box, linear-gradient(to right, ${palette.secondary.main} 0 0) border-box`,
            ".MuiChip-deleteIcon": {
              color: palette.secondary.main,
            },
          },
        },
        deleteIcon: {
          color: palette.primary.main,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          background: `linear-gradient(135deg, ${palette.secondary.main} 30%, ${palette.primary.main} 95%)`,
          boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
          color: "#FFFFFF",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          background: `linear-gradient(90deg, ${palette.secondary.main} 30%, ${palette.primary.main} 95%)`,
          height: "5px",
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        TransitionComponent: Zoom,
      },
      styleOverrides: {
        arrow: {
          color: alpha(palette.secondary.main, 0.48),
        },
        tooltip: {
          backgroundColor: alpha(palette.secondary.main, 0.48),
        },
      },
    },
  },
});
